// Locale → copy for the public face data policy at /face-data-policy (Photohawk Studio and Photohawk Family), following
// the site's language like /face-data-changes-2026: English (source of truth), Spanish and Portuguese; any other
// language falls back to English. The full Photohawk Family policy (/face-data-policy/family) is English only.
import { baseLang } from "@/lib/seo/site";
import en, { type FaceDataPolicyCopy, type ProductPolicy } from "./copy.en";
import es from "./copy.es";
import pt from "./copy.pt";

/** The one official face data policy page. Linked from the footers, /privacy, /biometric-data-retention and
 *  /face-data-changes-2026. */
export const FACE_DATA_POLICY_PATH = "/face-data-policy";
/** The full Photohawk Family policy (photohawk-personal legal/face-data-policy.md). The app links
 *  photohawk.com/personal/face-data-policy, a 301 to here (src/lib/seo/redirects.ts). */
export const FAMILY_FACE_DATA_POLICY_PATH = "/face-data-policy/family";

export type FaceDataProduct = ProductPolicy["id"];
export const FACE_DATA_PRODUCTS: readonly FaceDataProduct[] = ["studio", "family"];
/** A link straight to one product's tab. */
export const faceDataPolicyHref = (product: FaceDataProduct) => `${FACE_DATA_POLICY_PATH}#${product}`;

export const FACE_DATA_POLICY_LANGS = ["en", "es", "pt"] as const;

const COPY_BY_LANG: Record<string, FaceDataPolicyCopy> = { en, es, pt };

export const getFaceDataPolicyCopy = (lang: string | undefined): FaceDataPolicyCopy =>
  COPY_BY_LANG[baseLang(lang)] ?? en;

export type { FaceDataPolicyCopy, ProductPolicy };
